import { render } from "./UserGuideSectionTree.vue?vue&type=template&id=36e59108&scoped=true"
import script from "./UserGuideSectionTree.vue?vue&type=script&lang=js"
export * from "./UserGuideSectionTree.vue?vue&type=script&lang=js"

import "./UserGuideSectionTree.vue?vue&type=style&index=0&id=36e59108&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e59108"]])

export default __exports__